// ABGLAC uses reservation-system codes for these destinations.
const abglacCountryCodes = {
  bl: 'by',
  sx: 'zy',
};

export const getRentalConditionsUrl = (countryCode, brand) => {
  const country = (countryCode || '').trim().toLowerCase();
  const abglacCountry = abglacCountryCodes[country] || country;

  return `https://abglac.com/rental-conditions/${abglacCountry}/${brand}?lang=pt`;
};
